module.exports = __webpack_public_path__ + "media/images/stripe/light-on-dark@3x-4fc85b8433192aa616b032139a7fcae9.png";